import LocationsMenuNavItem from './LocationsMenuNavItem';

export default LocationsMenuNavItem;
